export const Messages = {
  SomethingWentWrong: 'Something went wrong. Please try again.',
  InternalServerError: 'Internal server error.',
  InternetConnectionError:
    'We are not able to serve you at the moment, please try again after some time',
  NetworkError: 'Network Error',
  OTPValidError: 'Please enter valid otp number.',
  NewVersionUpdateHeading: 'New Version Update',
  NewVersionUpdateMessage:
    'There is a new version of the application available with exciting new features!. To access new features, log out and log back in to the application.',
  DeleteMessage: 'Are you sure you want to perform this action?',
  DeleteHeading: 'Confirm dialog',
  PositiveMessage: 'Yes',
  NegativeMessage: 'No',
  PatientSaveSuccess: 'Patient saved successfully.',
  PatientSaveError: 'Unable to save patient. Please try again.',
  PatientPhotoUpdateSuccess: 'Profile photo updated successfully.',
  PatientPhotoUpdateError: 'Failed to update profile photo. Please try again.',
  PatientPhotoInvalidType: 'Only JPEG, JPG, or PNG images are allowed.',
  PatientPhotoSizeExceeds: 'Photo size exceeds limit. Maximum allowed size is {0}MB.',
  PatientPhotoUploadWarning: 'Patient saved, but photo upload failed. You can re-upload from the patient profile.',
  PatientPhotoDeleteHeading: 'Delete Profile Photo',
  PatientPhotoDeleteMessage: 'Are you sure you want to delete this patient\'s profile photo? This action cannot be undone.',
  PatientPhotoDeleteSuccess: 'Profile photo deleted successfully.',
  ContactSavedSuccess: 'Contact saved successfully',
  EmailSendSuccess: 'Email sent successfully',
  AppointmentSavedSuccess: 'Appointment saved successfully',
  AppointmentDateError: 'Please select future date/time for appointment.',
  LeaveSavedSuccess: 'Leave saved successfully',
  LocationSavedSuccess: 'Location saved successfully',
  ReminderTemplateChangedSuccess: 'Reminder template changed successfully',
  NotificationSettingChangedSuccess:
    'Notification setting changed successfully',
  SMSSendSuccess: 'SMS sent successfully',
  RoleSavedSuccess: 'Role saved successfully',
  UserSavedSuccess: 'User saved successfully',
  UserPermissionSavedSuccess: 'User permission saved successfully',
  ProfessionalSavedSuccess: 'Professional details saved successfully',
  IdentitySavedSuccess: 'Identity saved successfully',
  ChangePasswordSuccess: 'Password changed successfully',
  UserLoginLogsDeleteMessage:
    'Are you sure you want to delete user login logs older than the last 60 days',
  UserLoginLogsDeleteHeading: 'Delete User Login Logs',
  UserLoginLogsDeleteSuccess:
    'User login logs older than last 60 days deleted successfully',
  CredentialLogsDeleteMessage:
    'Are you sure you want to delete credential logs older than the last 60 days',
  CredentialLogsDeleteHeading: 'Delete Credential Logs',
  CredentialLogsDeleteSuccess:
    'Credential logs older than last 60 days deleted successfully',
  ErrorLogsDeleteMessage:
    'Are you sure you want to delete error logs older than the last 60 days',
  ErrorLogsDeleteHeading: 'Delete Error Logs',
  ErrorLogsDeleteSuccess:
    'Error logs older than last 60 days deleted successfully',
  EmailLogsDeleteMessage:
    'Are you sure you want to delete email logs older than the last 60 days',
  EmailLogsDeleteHeading: 'Delete Email Logs',
  EmailLogsDeleteSuccess:
    'Email logs older than last 60 days deleted successfully',
  SMSLogsDeleteMessage:
    'Are you sure you want to delete SMS logs older than the last 60 days',
  SMSLogsDeleteHeading: 'Delete SMS Logs',
  SMSLogsDeleteSuccess: 'SMS logs older than last 60 days deleted successfully',
  ActionLogsDeleteMessage:
    'Are you sure you want to delete action logs older than the last 60 days',
  ActionLogsDeleteHeading: 'Delete Action Logs',
  ActionLogsDeleteSuccess:
    'Action logs older than last 60 days deleted successfully',
  PractitionerSavedSuccess: 'Practitioner saved successfully',
  AssignedPractitionerSavedSuccess: 'Assigned practitioner saved successfully',
  TaskSavedSuccess: 'Task saved successfully',
  TaskMarkAsCompletedSuccess: 'Task marked as completed successfully',
  TaskDeleteMessage: 'Are you sure you want to delete this task?',
  TaskDeleteHeading: 'Delete Task',
  TaskDeleteSuccess: 'Task deleted successfully',
  CommentAddedSuccess: 'Comment added successfully',
  PatientInvoiceSavedSuccess: 'Patient invoice saved successfully',
  PatientDocumentUploadSuccess: 'Patient document uploaded successfully',
  PatientDocumentDeleteSuccess: 'Patient document deleted successfully',
  PatientDocumentDeleteHeading: 'Delete Patient Document',
  PatientDocumentDeleteMessage:
    'Are you sure you want to delete this patient document?',
  PatientPrescriptionSavedSuccess: 'Patient prescription saved successfully',
  PatientPrescriptionPublishSuccess:
    'Patient prescription published successfully',
  PatientPrescriptionDeleteMessage:
    'Are you sure you want to delete this patient prescription?',
  PatientPrescriptionDeleteHeading: 'Delete patient prescription',
  PatientPrescriptionDeleteSuccess: 'Patient prescription deleted successfully',
  PatientVaccineSavedSuccess: 'Patient vaccine saved successfully',
  PatientVaccineDeleteMessage:
    'Are you sure you want to delete this patient vaccine?',
  PatientVaccineDeleteHeading: 'Delete patient vaccine',
  PatientVaccineDeleteSuccess: 'Patient vaccine deleted successfully',
  PatientInvestigationOrderSavedSuccess:
    'Patient investigation order saved successfully',
  PatientInvestigationOrderDeleteMessage:
    'Are you sure you want to delete this patient investigation order?',
  PatientInvestigationOrderDeleteHeading: 'Delete patient investigation order',
  PatientInvestigationOrderDeleteSuccess:
    'Patient investigation order deleted successfully',
  PatientInvestigationResultSavedSuccess:
    'Patient investigation result saved successfully',
  PatientInvestigationResultDeleteMessage:
    'Are you sure you want to delete this patient investigation result?',
  PatientInvestigationResultDeleteHeading:
    'Delete patient investigation result',
  PatientInvestigationResultDeleteSuccess:
    'Patient investigation result deleted successfully',
  ReferralSavedSuccess: 'Referral saved successfully',
  MessageSendSuccess: 'Messages sent successfully',
  ReferralDeleteMessage: 'Are you sure you want to delete this referral?',
  ReferralDeleteHeading: 'Delete referral',
  ReferralDeleteSuccess: 'Referral deleted successfully',
  DeleteContactMessage: 'Are you sure you want to delete this contact?',
  DeleteContactHeading: 'Delete Contact',
  DeleteContactSuccess: 'Contact deleted successfully',
  CancelAppointmentMessage: 'Are you sure you want to cancel appointment?',
  CancelAppointmentHeading: 'Cancel Appointment',
  CancelAppointmentSuccess: 'Appointment cancelled successfully',
  ChangeAppointmentSuccess: 'Appointment status changed successfully',
  DeleteProfessionalHeading: 'Delete Professional',
  DeleteProfessionalMessage:
    'Are you sure you want to delete this professional?',
  DeleteProfessionalSuccess: 'Professional deleted successfully',
  DeleteLocationMessage: 'Are you sure you want to delete this location?',
  DeleteLeaveMessage: 'Are you sure you want to delete this leave?',
  DeleteLeaveHeading: 'Delete Leave',
  DeleteLeaveSuccess: 'Leave deleted successfully',
  DeleteLocationHeading: 'Delete Location',
  DeleteLocationSuccess: 'Location deleted successfully',
  DeleteAssignedPractitionerMessage:
    'Are you sure you want to delete this assigned practitioner?',
  DeleteAssignedPractitionerHeading: 'Delete assigned practitioner',
  DeleteAssignedPractitionerSuccess:
    'Assigned practitioner deleted successfully',
  DeletePractitionerMessage:
    'Are you sure you want to delete this practitioner?',
  DeletePractitionerHeading: 'Delete Practitioner',
  DeletePractitionerSuccess: 'Practitioner deleted successfully',
  DeleteRoleMessage: 'Are you sure you want to delete this role?',
  DeleteRoleHeading: 'Delete Role',
  DeleteRoleSuccess: 'Role deleted successfully',
  DeleteIdentityMessage: 'Are you sure you want to delete this identity?',
  DeleteIdentityHeading: 'Delete Identity',
  DeleteIdentitySuccess: 'Identity deleted successfully',
  DeleteVisitNoteHeading: 'Delete Visit Note',
  DeleteVisitNoteMessage:
    'Are you sure you want to delete this visit note template?',
  DeleteVisitNoteSuccess: 'Visit note template deleted successfully',
  DeleteReportTemplateHeading: 'Delete Report/Letter',
  DeleteReportTemplateMessage:
    'Are you sure you want to delete this report/letter template?',
  DeleteReportTemplateSuccess: 'Report/Letter template deleted successfully',
  DeleteQuestionnaireTemplateHeading: 'Delete Questionnaire',
  DeleteQuestionnaireTemplateMessage:
    'Are you sure you want to delete this questionnaire template?',
  DeleteQuestionnaireTemplateSuccess:
    'Questionnaire template deleted successfully',
  DeleteSMSTemplateHeading: 'Delete SMS Template',
  DeleteSMSTemplateMessage:
    'Are you sure you want to delete this sms template?',
  DeleteSMSTemplateSuccess: 'SMS template deleted successfully',
  DeleteEmailTemplateHeading: 'Delete Email Template',
  DeleteEmailTemplateMessage:
    'Are you sure you want to delete this email template?',
  DeleteEmailTemplateSuccess: 'Email template deleted successfully',
  DeleteFormGroupHeading: 'Delete Question Group',
  DeleteFormGroupMessage:
    'Are you sure you want to delete this question group?',
  DeleteFormGroupSuccess: 'Question group deleted successfully',
  DeleteFormQuestionHeading: 'Delete Question',
  DeleteFormQuestionMessage: 'Are you sure you want to delete this question?',
  DeleteFormQuestionSuccess: 'Question deleted successfully',
  FileSizeExeedsError: 'File size exceeds limit. Maximum allowed size is 25MB.',
  DeletePatientDiagnosisHeading: 'Delete Diagnosis',
  DeletePatientDiagnosisMessage:
    'Are you sure you want to delete this diagnosis?',
  DeletePatientDiagnosisSuccess: 'Diagnosis deleted successfully',
  DeletePatientAllergyHeading: 'Delete Allergy',
  DeletePatientAllergyMessage: 'Are you sure you want to delete this allergy?',
  DeletePatientAllergySuccess: 'Allergy deleted successfully',
  DeletePatientVitalHeading: 'Delete Vital',
  DeletePatientVitalMessage: 'Are you sure you want to delete this vital?',
  DeletePatientVitalSuccess: 'Vital deleted successfully',
  DeletePatientInjectionHeading: 'Delete Injection',
  DeletePatientInjectionMessage:
    'Are you sure you want to delete this injection?',
  DeletePatientInjectionSuccess: 'Injection deleted successfully',
  DeletePatientQuestionnaireHeading: 'Delete Questionnaire',
  DeletePatientQuestionnaireMessage:
    'Are you sure you want to delete this questionnaire?',
  DeletePatientQuestionnaireSuccess: 'Questionnaire deleted successfully',
  DeletePatientVisitHeading: 'Delete Visit Note',
  DeletePatientVisitMessage: 'Are you sure you want to delete this visit note?',
  DeletePatientVisitSuccess: 'Visit note deleted successfully',
  WorkingHoursSaveSuccess: 'Working hours saved successfully',
  NotificationDeleteSuccess: 'Notification deleted successfully',
  NotificationDeleteHeading: 'Delete Notification',
  NotificationDeleteMessage:
    'Are you sure you want to delete this notification?',
  InvalidFileTypeError:
    'Invalid file type. Only .pdf, .doc, .docx, .jpeg, .jpg, .png files are allowed.',
  InvalidPDFFileTypeError: 'Invalid file type. Only .pdf files are allowed.',
  LanguageAddSuccess: 'Language added successfully',
  LanguageEditSuccess: 'Language updated successfully',
  TagMasterAddSuccess: 'Tag Master added successfully',
  TagMasterEditSuccess: 'Tag Master updated successfully',
  PharmacyAddSuccess: 'Pharmacy added successfully',
  PharmacyEditSuccess: 'Pharmacy updated successfully',
  DiagnosisAddSuccess: 'Diagnosis added successfully',
  DiagnosisEditSuccess: 'Diagnosis updated successfully',
  AllergyAddSuccess: 'Allergy added successfully',
  AllergyEditSuccess: 'Allergy updated successfully',
  VitalAddSuccess: 'Vital added successfully',
  VitalEditSuccess: 'Vital updated successfully',
  InjectionAddSuccess: 'Injection added successfully',
  InjectionEditSuccess: 'Injection updated successfully',
  IdentityTypeAddSuccess: 'Patient identity type added successfully',
  IdentityTypeEditSuccess: 'Patient identity type updated successfully',
  RXDoseUnitAddSuccess: 'RX dose unit added successfully',
  RXDoseUnitEditSuccess: 'RX dose unit updated successfully',
  RXFrequencyAddSuccess: 'RX frequency added successfully',
  RXFrequencyEditSuccess: 'RX frequency updated successfully',
  RXFoodAddSuccess: 'RX food added successfully',
  RXFoodEditSuccess: 'RX food updated successfully',
  MedicineAddSuccess: 'Medicine added successfully',
  MedicineEditSuccess: 'Medicine updated successfully',
  VaccineSiteAddSuccess: 'Injection/Vaccine site added successfully',
  VaccineSiteEditSuccess: 'Injection/Vaccine site updated successfully',
  VaccineRouteAddSuccess: 'Injection/Vaccine route added successfully',
  VaccineRouteEditSuccess: 'Injection/Vaccine route updated successfully',
  VaccineDoseUnitAddSuccess: 'Injection/Vaccine dose unit added successfully',
  VaccineDoseUnitEditSuccess:
    'Injection/Vaccine dose unit updated successfully',
  CenterAddSuccess: 'Center added successfully',
  CenterEditSuccess: 'Center updated successfully',
  LabTypeRequired: 'Please select atlease one lab type',
  TestAddSuccess: 'Test added successfully',
  TestEditSuccess: 'Test updated successfully',
  QualificationAddSuccess: 'Qualification added successfully',
  QualificationEditSuccess: 'Qualification updated successfully',
  ProfessionAddSuccess: 'Profession added successfully',
  ProfessionEditSuccess: 'Profession updated successfully',
  ExpertiseAddSuccess: 'Expertise added successfully',
  ExpertiseEditSuccess: 'Expertise updated successfully',
  InvoiceItemAddSuccess: 'Invoice item added successfully',
  InvoiceItemEditSuccess: 'Invoice item updated successfully',
  PatientInvoiceItemSavedSuccess: 'Invoice item saved successfully',
  DeleteInvoiceMessage: 'Are you sure you want to delete this Invoice?',
  DeleteInvoiceHeading: 'Delete Invoice',
  DeleteInvoiceSuccess: 'Invoice deleted successfully',
  PatientInvoicePaymentSavedSuccess: 'Invoice Payment saved successfully',
  DeleteInvoicePaymentMessage:
    'Are you sure you want to delete this invoice payment?',
  DeleteInvoicePaymentHeading: 'Delete Payment',
  DeleteInvoicePaymentSuccess: 'Invoice Payment deleted successfully',
  DeleteInvoiceItemMessage:
    'Are you sure you want to delete this Invoice Item?',
  DeleteInvoiceItemHeading: 'Delete Invoice Item',
  DeleteInvoiceItemSuccess: 'Invoice Item deleted successfully',
  InvalidFeeAmount: 'Item discount amount must not be more than fee amount',
  SMSTemplateAddSuccess: 'SMS template added successfully',
  SMSTemplateEditSuccess: 'SMS template updated successfully',
  VisitNoteCloneSuccess: 'Visit note template cloned successfully',
  VisitNoteAddSuccess: 'Visit note template added successfully',
  VisitNoteEditSuccess: 'Visit note template updated successfully',
  ReportCloneSuccess: 'Report template cloned successfully',
  ReportTemplateAddSuccess: 'Report template added successfully',
  ReportTemplateEditSuccess: 'Report template updated successfully',
  EmailTemplateAddSuccess: 'Email template added successfully',
  EmailTemplateEditSuccess: 'Email template updated successfully',
  QuestionnaireCloneSuccess: 'Questionnaire cloned successfully',
  QuestionnaireAddSuccess: 'Questionnaire template added successfully',
  QuestionnaireEditSuccess: 'Questionnaire template updated successfully',
  FormGroupAddSuccess: 'Question group added successfully',
  FormGroupEditSuccess: 'Question group updated successfully',
  QuestionManageSuccess: 'Questions updated successfully',
  GlobalSettingUpdateSuccess: 'Global settings updated successfully',
  SMSSettingUpdateSuccess: 'SMS settings updated successfully',
  SMTPSettingUpdateSuccess: 'SMTP settings updated successfully',
  ReminderPreferenceSettingUpdateSuccess:
    'Patient Reminder preference settings updated successfully',
  ReminderTemplatesSettingUpdateSuccess:
    'Reminder templates settings updated successfully',
  PractitionerNotificationSettingUpdateSuccess:
    'Practitioner notification settings updated successfully',
  PatientEducationLibrarySettingUpdateSuccess:
    'Patient Education Library settings updated successfully',
  LetterheadUpdateSuccess: 'Letterhead updated successfully',
  QuestionnaireAssignSuccess: 'Questionnaire assigned successfully',
  QuestionnaireSaveSuccess: 'Questionnaire saved successfully',
  QuestionnaireSubmitSuccess: 'Questionnaire submitted successfully',
  EmailResendSuccess: 'Email added to queue successfully',
  CopySuccessMessage: `Copied to clipboard`,
  PatientVisitAddSuccess: 'Visit added successfully',
  PatientVisitEditSuccess: 'Visit updated successfully',
  PatientVisitEmailSendSuccess: 'Email sent successfully',
  PatientVisitEmailSendError: 'Error while sending email',
  PatientVisitPublishHeading: 'Publish visit note',
  PatientVisitPublishMessage: 'Are you sure you want to publish visit note?',
  PatientVisitDraftPrescriptionsPublishMessage:
    'There are draft prescriptions attached to this visit. Do you want to publish them along with the visit note?',
  PatientVisitPublishSuccess: 'Visit published successfully',
  PatientVisitTemplateChangeHeading: 'Visit note template',
  PatientVisitTemplateChangMessage:
    'Are you sure you want to change visit note template as this will replace the old content?',
  InvoiceMarkAsCompletedSuccess: 'Invoice marked as completed successfully',
  InoviceMarkAsCompletedConfirmMessage:
    'Are you sure you want to mark this invoice as completed? Marking this invoice as completed will record any remaining amount as an adjustment.',
  InoviceMarkAsCompletedHeading: 'Mark As Completed',
  DeletePatientInsuranceHeading: 'Delete Insurance',
  DeletePatientInsuranceMessage: 'Are you sure you want to delete this insurance?',
  DeletePatientInsuranceSuccess: 'Insurance deleted successfully',
  InsuranceAddSuccess: 'Insurance details added successfully',
  InsuranceEditSuccess: 'Insurance details updated successfully',
  DeletePatientPreferredPharmacyHeading: 'Delete Preferred Pharmacy',
  DeletePatientPreferredPharmacyMessage:
    'Are you sure you want to delete this preferred pharmacy?',
  DeletePatientPreferredPharmacySuccess: 'Preferred pharmacy deleted successfully',
  PatientPreferredPharmacySavedSuccess: 'Preferred pharmacy saved successfully',
  QRCodeNotGenerated: 'QR Code not generated.',
  QRCodeGenerateError: 'Failed to generate QR Code SVG.',
  QRCodeDownloadError: 'Failed to download QR code image.',
  QRCodeCopySuccess: 'QR code link copied to clipboard!',
  EquipmentAddSuccess: 'Equipment added successfully',
  EquipmentEditSuccess: 'Equipment updated successfully',
  RoomAddSuccess: 'Room added successfully',
  RoomEditSuccess: 'Room updated successfully',
  QRCodeCopyError: 'Failed to copy QR code link.',
  CarePlanSavedSuccess: 'Care plan saved successfully.',
  DeletePatientCarePlanHeading: 'Delete Care Plan',
  DeletePatientCarePlanMessage: 'Are you sure you want to delete this care plan?',
  DeletePatientCarePlanSuccess: 'Care plan deleted successfully.',
  NutritionPlanAddSuccess: 'Nutrition plan added successfully',
  NutritionPlanEditSuccess: 'Nutrition plan updated successfully',
  DeletePatientNutritionPlanDetailHeading: 'Delete Meal',
  DeletePatientNutritionPlanDetailMessage: 'Are you sure you want to delete this meal?',
  DeletePatientNutritionPlanDetailSuccess: 'Meal deleted successfully',
  NutritionPlanDetailAddSuccess: 'Meal added successfully',
  NutritionPlanDetailEditSuccess: 'Meal updated successfully',
  PatientEducationCategoryAddSuccess: 'Patient education category added successfully',
  PatientEducationCategoryEditSuccess: 'Patient education category updated successfully',
  PatientEducationAddSuccess: 'Patient education added successfully',
  PatientEducationEditSuccess: 'Patient education updated successfully',
  PatientEducationDeleteSuccess: 'Patient education deleted successfully',
  DeletePatientEducationHeading: 'Delete Patient Education',
  DeletePatientEducationMessage: 'Are you sure you want to delete this patient education item?',
  InvalidUrl: 'Please enter a valid URL (e.g. https://example.com)',
  LegalDocumentAddSuccess: 'Legal document created successfully',
  LegalDocumentEditSuccess: 'Legal document updated successfully',
  LegalDocumentFileSizeExceeded: 'File size cannot exceed 25 MB.',
  PleaseUploadPdfFile: 'Please upload a PDF document file.',
  InvalidPdfFile: 'Invalid file format. Only PDF files are allowed.',
  PatientLegalAcceptanceCreateWarning: 'Patient saved, but legal acceptance record could not be created.',
};
